import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';


// 异步方法
import {
  getCompanyByNameAction
} from '@ivymobi/orbit-core/business/tenant';
// 工具方法
import { get } from 'lodash';
import clsx from 'clsx';
// 引用的组件
import { Form, TextInput, isEmail, required as isRequired } from '../../components';
import { ToolbarValid } from '../../components/form/form';
import CustomizedInputBase from './searchView';
import CompanyInput from './companyinput';
import SmsCodeInput from './smscodeinput';
import SelectInput from './selectinput';
import SelectBusinessType from './SelectBusinessType';
import { createStyles, makeStyles } from '@mui/styles';
import { Box, Dialog, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';


const IsPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};


const useSearchStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: '20px',
      boxShadow: 'unset',
      border: '1px solid gray',
      marginLeft: '0px',
      display: 'flex',
      alignItems: 'center',
      width: IsPC() ? '400px' : '100%',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 8,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    flexbox1: {
      display: 'flex',
      flexDirection: 'column',
      height: '60vh',
      padding: '20px'
    },
    flexbox2: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '40px',
      borderBottom: '1px solid #d1d1d1'
    },
    box1: {
      width: '100%',
      height: '1px',
      background: '#dbd8d8',
      marginTop: '10px',
    },
    title1: {
      fontSize: '19px',
      marginBottom: '15px'
    },
    fontstyle: {
      fontSize: '14px',
      color: 'gray',
    },
    pt10: {
      paddingTop: theme.spacing(1.25),
    },
    flexstyle1: {
      flexGrow: 1,
      overflow: 'auto'
    }

  }),
);

export default function LeadForm(props) {
  const {
    user, doSendCode, onSubmit, onClose, visitorInfo, leadProfile, share,
  } = props;
  const tenant = get(share, ['tenant'], {});
  const required = get(share, ['required'], []) || [];
  const { info } = tenant;
  const { industries = [] } = info;
  // tnt_info  businessType
  const businessType = get(tenant, ['tnt_info', 'businessType'], []);

  const userPhone = user?.phone;
  const defaultValues = Object.assign(
    {}, leadProfile,
    { message: '' },
    userPhone && { countryCode: user.countryCode, phone: userPhone },
  );
  const fields = visitorInfo.filter(name => name !== 'phone' && name !== 'industry' && name !== 'businesstype');
  const hasIndustry = visitorInfo.includes('industry');
  const hasIndustrySelect = industries?.length !== 0 ? true : false;
  const requiredIndestry = required.includes('industry');
  
  const hasBussinesstype = visitorInfo.includes('businesstype');
  const requiredBusinessType = required.includes('businesstype');

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const diyclass = useSearchStyles();
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [result, setResult] = useState([]);
  const [select, setSelect] = useState(defaultValues?.companyName);
  // 获取placeholder
  const placeholders = {
    companyName:t('share.form.placholder.companyName'),
  }
  const getPlaceholder = (name: string) => {
    return placeholders[name] || '';
  }
  useEffect(() => {
    if(searchText.length<3)
      return;
    dispatch(getCompanyByNameAction({ name: searchText, user: { token: null }, tenant: null }))
    .then(res => {
      setResult(res.data.rows);
    });
  }, [searchText]);

  return (
    <>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <Box className={diyclass.flexbox1}>
          <Box className={diyclass.title1}>公司名称</Box>
          <CustomizedInputBase
            defaultTitle={'请输入公司名称'}
            diyClasses={diyclass}
            searchText={searchText}
            setSearchText={setSearchText} 
          />
          <Box className={clsx(diyclass.fontstyle, diyclass.pt10)}>请在搜索结果中选择正确的公司名称</Box>
          <Box className={diyclass.fontstyle}>请输入至少三个字符</Box>
          <Box className={diyclass.box1}></Box>
          <Box className={diyclass.flexstyle1}>
            {result?.map((item, index) => {
              return (
                <Box 
                  key={`company_${index}`} 
                  onClick={() => {
                    setSelect(item.companyName);
                    setOpen(false);
                  }} 
                  className={diyclass.flexbox2}
                >
                  {item.companyName}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Dialog>
      <Box display='flex' justifyContent='space-between' >
        <DialogTitle>
          {/* 分享的弹框 111111111111111111  打开时验证输入信息弹框 我感兴趣请联系我 */}
          {t('share.form.continueShare')}
        </DialogTitle>
        <IconButton onClick={onClose} ><Close /></IconButton>
      </Box>
      <Form 
        onSubmit={onSubmit} 
        toolbar={<ToolbarValid />} 
        defaultValues={defaultValues} 
        pb={3} 
      >
        <TextInput name='phone' label={t('share.form.phone')} fullWidth required margin='dense'
          disabled={!!userPhone} variant='standard'
        />
        {!userPhone && <SmsCodeInput doSendCode={doSendCode} />}
        {fields.map(name => {
          // console.log(required.indexOf(name));
          if (name === 'companyName' && tenant.tntindex === 'songxia') {
            return <CompanyInput key={`songxiacompany`} onclick={() => {
              setOpen(true);
            }} select={select}></CompanyInput>;
          }
          const validates = [];
          if (required.indexOf(name) !== -1) {
            validates.push(isRequired());
          }
          if (name === 'email') {
            validates.push(isEmail());
          }
          return <TextInput
            fullWidth variant='standard' margin='dense' 
            placeholder={getPlaceholder(name)}
            required = {required.indexOf(name) !== -1 ? true : false}
            key={name} name={name} label={t(`share.form.${name}`)}
            type={name === 'email' ? 'email' : ''}
            // validate={name === 'email' ? [isEmail()] : []}
            validate={validates}
          />;
        })}
        {/* 所属行业  下拉框形式 */}
        {hasIndustry && hasIndustrySelect && <SelectInput
          industries={industries}
          required={requiredIndestry} 
          validate={requiredIndestry ? [isRequired()] : []}
        />}
        {/* 所属行业  输入框形式 */}
        {hasIndustry && !hasIndustrySelect && <TextInput
          fullWidth variant='standard' margin='dense' required={requiredIndestry}
          key={'industry'} name={'industry'} label={t('share.form.industry')}
        />}
        {/* 业务类型，默认只有下拉框 */}
        {hasBussinesstype && <SelectBusinessType 
          list={businessType} 
          required={requiredBusinessType} 
        />}

        <TextInput name='message' label={t('share.form.message')}
          fullWidth multiline variant='standard' margin='dense'
        />
        {/* <Button variant='outlined' color='primary' fullWidth type='submit'
          style={{ marginTop: '16px' }}
        >
          {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040208')}
        </Button> */}
      </Form>
    </>
  );
}

export  function LeadMustForm(props) {
  const {
    user, doSendCode, onSubmit, onClose, visitorInfo, leadProfile, share,
  } = props;
  const tenant = get(share, ['tenant'], {});
  const required = get(share, ['required'], []) || [];
  const { info } = tenant;
  const { industries = [] } = info;
  // tnt_info  businessType
  const businessType = get(tenant, ['tnt_info', 'businessType'], []);
  
  

  const fields = visitorInfo.filter(name => name !== 'phone' && name !== 'industry' && name !== 'businesstype');
  const hasIndustry = visitorInfo.includes('industry');
  const hasIndustrySelect = industries?.length !== 0 ? true : false;
  const requiredIndestry = required.includes('industry');

  const hasBussinesstype = visitorInfo.includes('businesstype');
  const requiredBusinessType = required.includes('businesstype');

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const diyclass = useSearchStyles();
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [result, setResult] = useState([]);
  const [defaultValues, setDefaultValue] = useState({});
  const [select, setSelect] = useState(undefined);
  const userPhone = user?.phone;
  // const defaultValues = Object.assign(
  //   {}, leadProfile,
  //   { message: '' },
  //   userPhone && { countryCode: user.countryCode, phone: userPhone },
  // );
  // 获取placeholder
  const placeholders = {
    companyName:t('share.form.placholder.companyName'),
  }
  const getPlaceholder = (name: string) => {
    return placeholders[name] || '';
  }
  useEffect(() => {
    if(searchText.length<3)
      return;
    dispatch(getCompanyByNameAction({ name: searchText, user: { token: null }, tenant: null }))
    .then(res => {
      setResult(res.data.rows);
    });
  }, [searchText]);

  const [isFormReady, setIsFormReady] = useState(true);
  useEffect(() => {
    // const userPhone = user?.phone;
    setIsFormReady(false);
    const defaultV = Object.assign(
      {}, leadProfile,
      { message: '' },
      userPhone && { countryCode: user.countryCode, phone: userPhone },
    );
    setDefaultValue(defaultV);
    setSelect(defaultV?.companyName)
    setTimeout(() => {
      setIsFormReady(true);
    }, 0);
    console.log('页面重绘事件执行', isFormReady);
  }, [leadProfile, user]);

  // console.log('defaultValuesdefaultValuesdefaultValues', defaultValues);

  return (
    <>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <Box className={diyclass.flexbox1}>
          <Box className={diyclass.title1}>公司名称</Box>
          <CustomizedInputBase
            defaultTitle={'请输入公司名称'}
            diyClasses={diyclass}
            searchText={searchText}
            setSearchText={setSearchText} 
          />
          <Box className={clsx(diyclass.fontstyle, diyclass.pt10)}>请在搜索结果中选择正确的公司名称</Box>
          <Box className={diyclass.fontstyle}>请输入至少三个字符</Box>
          <Box className={diyclass.box1}></Box>
          <Box className={diyclass.flexstyle1}>
            {result?.map((item, index) => {
              return (
                <Box 
                  key={`company_${index}`} 
                  onClick={() => {
                    setSelect(item.companyName);
                    setOpen(false);
                  }} 
                  className={diyclass.flexbox2}
                >
                  {item.companyName}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Dialog>
      <Box display='flex' justifyContent='space-between' >
        <DialogTitle>
          {/* 分享的弹框 111111111111111111  打开时验证输入信息弹框 我感兴趣请联系我 */}
          {'输入信息方可继续'}
        </DialogTitle>
        <IconButton onClick={onClose} ><Close /></IconButton>
      </Box>
      {isFormReady && <Form
        onSubmit={onSubmit}
        toolbar={<ToolbarValid />}
        defaultValues={defaultValues}
        pb={3}
      >
        <TextInput name='phone' label={t('share.form.phone')} fullWidth required margin='dense'
          disabled={!!userPhone} variant='standard'
        />
        {!userPhone && <SmsCodeInput doSendCode={doSendCode} />}
        {fields.map(name => {
          // console.log(required.indexOf(name));
          if (name === 'companyName' && tenant.tntindex === 'songxia') {
            return <CompanyInput key={`songxiacompany`} onclick={() => {
              setOpen(true);
            }} select={select}></CompanyInput>;
          }
          const validates = [];
          if (required.indexOf(name) !== -1) {
            validates.push(isRequired());
          }
          if (name === 'email') {
            validates.push(isEmail());
          }
          return <TextInput
            placeholder={getPlaceholder(name)}
            fullWidth variant='standard' margin='dense' 
            required = {required.indexOf(name) !== -1 ? true : false}
            key={name} name={name} label={t(`share.form.${name}`)}
            type={name === 'email' ? 'email' : ''}
            // validate={name === 'email' ? [isEmail()] : []}
            validate={validates}
          />;
        })}
        {/* 所属行业  下拉框形式 */}
        {hasIndustry && hasIndustrySelect && <SelectInput 
          industries={industries} 
          required={requiredIndestry}
          validate={requiredIndestry ? [isRequired()] : []}
        />}
        {/* 所属行业  输入框形式 */}
        {hasIndustry && !hasIndustrySelect && <TextInput
          fullWidth variant='standard' margin='dense' required={requiredIndestry}
          key={'industry'} name={'industry'} label={t('share.form.industry')}
        />}
        {/* 业务类型，默认只有下拉框 */}
        {hasBussinesstype && <SelectBusinessType 
          list={businessType} 
          required={requiredBusinessType} 
        />}

        {/* <Button variant='outlined' color='primary' fullWidth type='submit'
          style={{ marginTop: '16px' }}
        >
          {'提交'}
        </Button> */}
      </Form>}
    </>
  );
}